// import Backbone from 'backbone';
import tmpl from '../templates';
import {animEndEventName} from '@util/animation-prefixes';
import OptionDetailView from './optionDetailView';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var OptionGroupListView = Backbone.View.extend( {

    className: 'option-set-list',

    attributes: {
        'data-anim-state': 'start'
    },

    template: _.template( tmpl.optionGroupList ),

    $optionSet: [],

    initialize: function () {
        var $el = this.$el;

        this.$el.on( animEndEventName, 'li:first-child', function ( e ) {
            $el.attr( 'data-anim-state', 'done' );
        } );
    },

    beforeRender: function () {
        // undelegate/delegate view events with each render to avoid memory leak
        this.delegateEvents();
        this.listenTo( this.collection, 'error', this.onError );
        this.collection.handleOptionFilter();
    },

    getNextTarget: function () {
        var target = null,
            optionGroups = this.collection.models;

        for ( var i = 0; i < optionGroups.length; i++ ) {
            if ( !optionGroups[i].hasSelection() ) {
                target = this.$optionSet[i];
                break;
            }
        }

        return target;
    },

    render: function () {
        this.beforeRender();

        var optionGroups = this.$optionSet = [];

        this.closeOptionItems();
        this.collection.each( ( optionGroup ) => {
            var html = this.template( optionGroup.attributes ),
                $optionGroup = $( html );

            $optionGroup.find( '.option-list' ).append( this.renderOptionList( optionGroup ) );

            // store a reference to this collection group view
            optionGroups.push( $optionGroup[0] );

        } );

        this.$el.html( optionGroups );
        this.$el.attr( 'data-anim-state', 'opening' );
        return this;
    },

    renderOptionList: function ( optionGroup ) {
        var views = [];

        optionGroup.optionList.each( function ( option ) {
            views.push( new OptionDetailView( {model: option} ) );
        } );

        return this.showOptionItems( views );
    },

    onError: function ( err ) {
        app.validator.trigger( 'error:validation', {
            type: err.type,
            message: err.message,
            el: this.$el.find( '.option-set[data-group-id="' + err.groupId + '"] .group-label' )
        } );
    },

    /**
     * Garbage Collection
     * close zombie views/models
     */

    close: function () {
        this.collection.trigger( 'unset:current' );
        this.closeOptionItems();
        this.undelegateEvents();
        this.stopListening( this.collection );
        this.remove();
    },

    showOptionItems: function ( views ) {
        this._currentOptionItems = _.flatten( [
            views, this._currentOptionItems
        ], true );
        return _.map( views, function ( view ) {
            return view.render().el;
        } );
    },

    closeOptionItems: function () {
        var existingItems = this._currentOptionItems = this._currentOptionItems || [];
        while ( existingItems.length ) {
            existingItems.pop().close();
        }

        this._currentOptionItems || [];
    }

} );

export default OptionGroupListView;
